import PropTypes from 'prop-types';
import { Component } from 'react';
import Item from './NavbarMessagesDropdownItem';
import Translations from '../../utils/Translations';
import ReloadHelper from '../../utils/ReloadHelper';
import { trackNavbarIconClick } from '../../utils/GAHelper';

class NavbarMessagesDropdown extends Component {
	static pjaxLinkHandler(e) {
		if (e.currentTarget && e.currentTarget.href) {
			ReloadHelper.reloadWithPjax(e.currentTarget.href, e);
		}
	}

	constructor(props) {
		super(props);
	}

	render() {
		// create list
		const messageItems = this.props.messages.map((item) => <Item item={item} key={'item-' + item.channelId} />);

		if (messageItems.length > 0) {
			// add link to show all notifications
			messageItems.push(
				<li className="dropdown-menu__item__table -width-middle" key="link-show-all">
					<a
						href={this.props.messengerUrl}
						onClick={(e) => {
							NavbarMessagesDropdown.pjaxLinkHandler(e);
							trackNavbarIconClick('messages', this.props.messengerUrl);
						}}
						className="dropdown-menu__item -show-more"
					>
						<span className="dropdown-menu__item__cell -no-padding h-text-align-center">
							<i className="icon -icon-arrow-right-full" />{' '}
							<span className="h-text-underline">{Translations.get('NavbarMessagesShowAll')}</span>
						</span>
					</a>
				</li>,
			);

			return <ul className="dropdown-menu -width-wide h-list--unstyled-block">{messageItems}</ul>;
		} else {
			// add empty info
			messageItems.push(
				<li className="dropdown-menu__item__table" key="messages-empty">
					<a className="dropdown-menu__item">
						<span className="dropdown-menu__item__cell">
							<span className="icon">
								<i className="fa fa-fw fa-info-circle" />
							</span>
						</span>
						<span className="dropdown-menu__item__cell">
							<span className="text">{Translations.get('NavbarMessagesEmptyText')}</span>
						</span>
					</a>
				</li>,
			);

			return <ul className="dropdown-menu -width-middle h-list--unstyled-block">{messageItems}</ul>;
		}
	}
}

NavbarMessagesDropdown.propTypes = {
	messages: PropTypes.array.isRequired,
	messengerUrl: PropTypes.string.isRequired,
};

export default NavbarMessagesDropdown;
